import axios from '../../libs/netAxios'
import { scheduleFood } from '@/types/interface/Food/foodTypes'

export const getCategoriesByMerchId = (merchId: string) => {
  return axios.request({
    method: 'GET',
    url: `/api/Merch/${merchId}/merchFoodCategories`
  })
}

export const getCategories = (merchId: string) => {
  return axios.request({
    method: 'GET',
    url: `/api/Merch/${merchId}/merchFoodCategories`
  })
}

export const getFoodsByCategory = (categoryId: string) => {
  return axios.request({
    method: 'GET',
    url: `/api/MerchFood/merchFoodsByCategoryForBusiness?CategoryId=${categoryId}`
  })
}

export const scheduleAdd = (data: scheduleFood) => {
  return axios.request({
    method: 'POST',
    url: `/api/MerchFood/availability/schedule/add`,
    data
  })
}
